import { render, staticRenderFns } from "./GeneralTabs.vue?vue&type=template&id=70bff64a"
import script from "./GeneralTabs.vue?vue&type=script&lang=js"
export * from "./GeneralTabs.vue?vue&type=script&lang=js"
import style0 from "./GeneralTabs.vue?vue&type=style&index=0&id=70bff64a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports